<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Dossier enregistré
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{comments}}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Merci, votre dossier de candidature est en cours d'étude par un de nos centres de formation. Veuillez patienter, nous allons revenir vers vous.
          </div>
          <div class="dashboard-section-content-space"/>
          <div class="dashboard-section-content-italic">
            Vous recevrez une notification par email vous indiquant si votre dossier est éligible à la formation ASV (sous 15 jours ouvrés).
          </div>
        </div>
      </div>

      <div class="form-group">
        <button button class="btn btn-primary btn-block" @click="toFile">
          <span>Modifier ma candidature</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'

export default {
  name: "DashboardCandidatureSaved",
  components: {
    DashboardHeader
  },
  props: {
    firstname: String,
    purcentage: Number,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  },
  methods: {
    toFile: function () {
      this.$router.push({name: 'file'});
    }
  },
};
</script>
